/* ==========================================================================
   FarmDaddy product page  ·  fd-product.js   (loaded on the product template only)
   Variant matching, gallery + lightbox, quantity stepper, sticky mobile buy bar.
   Add-to-cart itself is handled by fd.js (the form carries data-fd-product-form).
   Product data comes from the inline <script data-fd-product-json> (no extra request).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-fd-product]');
  if (!root) return;
  var jsonEl = root.querySelector('[data-fd-product-json]');
  if (!jsonEl) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var product = JSON.parse(jsonEl.textContent);
  var FD = window.FD || {};
  var form = $('[data-fd-product-form]');
  var idInput = $('[data-fd-variant-id]');
  var atc = $('[data-fd-atc]');
  var soldNote = $('[data-fd-soldout]');
  var sticky = $('[data-fd-sticky]');
  var stickyBtn = $('[data-fd-sticky-atc]');

  /* Money ------------------------------------------------------------------- */
  function money(cents) {
    var v = cents / 100, whole = Math.abs(v - Math.round(v)) < 1e-9;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: FD.currency || 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (whole ? Math.round(v) : v.toFixed(2)); }
  }

  /* Variants ---------------------------------------------------------------- */
  var optionSets = $$('[data-fd-option]');
  function selected() {
    return optionSets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
  }
  function find(opts) {
    return product.variants.filter(function (v) {
      return opts.every(function (o, i) { return o === null || v['option' + (i + 1)] === o; });
    })[0] || null;
  }
  function currentVariant() { return optionSets.length ? find(selected()) : product.variants[0]; }

  function markUnavailable() {
    // Strike through values that have no purchasable variant given the other selections
    var sel = selected();
    optionSets.forEach(function (fs, i) {
      $$('input', fs).forEach(function (input) {
        var probe = sel.slice(); probe[i] = input.value;
        var any = product.variants.some(function (v) {
          return probe.every(function (o, k) { return v['option' + (k + 1)] === o; }) && v.available;
        });
        var label = $('label[for="' + input.id + '"]', fs);
        if (label) label.classList.toggle('is-unavailable', !any);
      });
    });
  }

  function setPrice(v) {
    var cur = $('[data-fd-price-current]'), cmp = $('[data-fd-price-compare]'), save = $('[data-fd-price-save]');
    cur.textContent = money(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    cmp.hidden = save.hidden = !onSale;
    if (onSale) { cmp.textContent = money(v.compare_at_price); save.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
    $('.fd-price', root).classList.toggle('fd-price--sale', !!onSale);
    var sp = $('[data-fd-sticky-price]'); if (sp) sp.textContent = money(v.price);
  }

  function setButtons(v) {
    var ok = !!v && v.available;
    var label = !v ? 'Unavailable' : v.available ? 'Add to cart' : 'Sold out';
    [atc, stickyBtn].forEach(function (b) { if (b) { b.disabled = !ok; b.textContent = label; } });
    if (soldNote) soldNote.hidden = ok || !v;
  }

  function onVariantChange() {
    var v = currentVariant();
    optionSets.forEach(function (fs) { var c = $('input:checked', fs), l = $('[data-fd-option-label]', fs); if (c && l) l.textContent = c.value; });
    markUnavailable();
    setButtons(v);
    if (!v) return;
    idInput.value = v.id;
    setPrice(v);
    if (v.featured_image && v.featured_image.id) {
      var thumb = $('[data-fd-thumb][data-image-id="' + v.featured_image.id + '"]');
      if (thumb) showThumb(thumb);
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) { /* non-critical */ }
  }
  optionSets.forEach(function (fs) { fs.addEventListener('change', onVariantChange); });
  if (optionSets.length) markUnavailable();

  /* Gallery ----------------------------------------------------------------- */
  var main = $('[data-fd-main]'), thumbs = $$('[data-fd-thumb]');
  var index = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }));
  function showThumb(t) {
    if (!main || !t) return;
    index = thumbs.indexOf(t);
    thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
    main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset'); main.alt = t.getAttribute('data-alt');
    t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
  var prev = $('[data-fd-prev]'), next = $('[data-fd-next]');
  function step(d) { if (thumbs.length) showThumb(thumbs[(index + d + thumbs.length) % thumbs.length]); }
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });

  // Swipe on touch devices
  var gMain = $('.fd-gallery__main'), startX = null;
  if (gMain) {
    gMain.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    gMain.addEventListener('touchend', function (e) { if (startX === null) return; var dx = e.changedTouches[0].clientX - startX; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); startX = null; });
  }

  // Lightbox (plain modal div from fd.js: Esc, click-outside, focus trap, scroll lock)
  var box = $('[data-fd-lightbox]'), boxImg = $('[data-fd-lightbox-img]'), zoom = $('[data-fd-zoom]');
  if (box && zoom && FD.modal) {
    var lightbox = FD.modal(box);
    zoom.addEventListener('click', function () {
      var t = thumbs[index];
      boxImg.src = t ? t.getAttribute('data-large') : main.src; boxImg.alt = main.alt;
      lightbox.open();
    });
    $('[data-fd-lightbox-close]', box).addEventListener('click', lightbox.close);
  }

  /* Sticky buy bar (mobile): visible once the main button has scrolled above the viewport */
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.hidden = !pastIt;
    }, { threshold: 0 }).observe(atc);
    stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
  }
})();
